import classNames from "classnames";
import { useNavigate } from 'react-router-dom'
import { MdChevronRight  } from "react-icons/md";

function SidebarOption ({to, children, className, activeClassName, handleOptionSelection, selected}){
    const navigate = useNavigate();


    const classes = classNames(
        'text-black', 
        className,
        selected === to && activeClassName
    );

    const handleClick = (event) => {
        if(event.metaKey || event.ctrlKey) return;
        event.preventDefault();
        handleOptionSelection(to)
        navigate(to)
    }
    return (
        <div className="grid grid-cols-[20px_auto] mt-4 text-lg">
            <div className="col-start-1">
                <div className="mt-1">
                    <span className="flex flex-row justify-left">
                        <a href={to}><MdChevronRight  /></a>
                    </span>
                </div>
            </div>
            <div className="col-start-2">
                <a className={classes} href={to} onClick={handleClick}>{children}</a>
            </div>
        </div>
    )
}

export default SidebarOption